import React from 'react';
import { permissions } from '@vanilla/services/PermissionService.js';

const MODULE_ALIASES = {
    clients: 'accounts',
    settings: 'integrations',
};

function resolveModule(module) {
    return MODULE_ALIASES[module] || module;
}

function checkAccess(module, action) {
    if (module === 'data-management') {
        return permissions.canAccessDataManagement();
    }
    const resolved = resolveModule(module);
    if (action === 'view') {
        return permissions.canView(resolved);
    }
    return permissions.can(resolved, action);
}

export default function RequirePermission({ module, action = 'view', children, fallback = null }) {
    if (!module || !checkAccess(module, action)) {
        if (fallback) return fallback;
        return (
            <div className="crm-page">
                <p className="text-sm text-muted-foreground">
                    Access denied. You do not have permission to view this page.
                </p>
            </div>
        );
    }
    return children;
}
